export default () => {
  document.querySelectorAll(".js-alert-banner").forEach((el, i) => {
    const closeButton = el.querySelector(".js-alert-banner__close");
    //Note: sessionStorage would expire when page session ends if we want to go that route
    const localStorage = window.localStorage;
    const id = el.getAttribute("id");

    // the id is required so we know which alert to show.
    if (!id) {
      return;
    }

    // has this alert been hidden?
    if (localStorage.getItem(id)) {
      // remove the alert
      el.remove();
    } else {
      // show the alert
      el.classList.add("alert-banner--visible");
      el.style.position = "relative"; // prevents the transition back to absolute
    }

    closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      localStorage.setItem(id, true);
      el.classList.remove("alert-banner--visible");

      el.addEventListener("transitionend", (event) => {
        if (event.propertyName === "opacity") {
          el.remove();
        }
      });
    });
  });
};
